import { getUser, getAccessToken } from './service/AuthService';
import { getUserGoal, setUserGoal } from './service/GoalService';
import { fetchGoalMilestones } from './service/GoalMilestoneService';

import GoalMilestoneCard from './components/GoalMilestoneCard';
import Timer from './Timer';
import ProblematicLogEntry from './ProblematicLogEntry';
import TextExpander from './TextExpander';


import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import nextBttn from './assets/nextBttn.svg';
import './css/Daily.css';
import './css/PopupForm.css';



const logFetchUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/problematiclogfetch';
const dailyContentUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/dailyfetch';

function convertTimestampToDateString(timestamp) {
    const date = new Date(timestamp);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    const dateString = date.toLocaleDateString('en-US', options)
    return dateString;
}

function convertTimestampToFullDateString(timestamp) {
    const date = new Date(timestamp);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
    };
    const dateString = date.toLocaleDateString('en-US', options)
    return dateString;
}

const Progress = () => {

    const entries = []
    const [entryHTML, setEntryHTML] = useState(null);
    const [timerHTML, setTimerHTML] = useState(null);
    const [lastSubmitDate, setLastSubmitDate] = useState('');
    const [lastRelapseDate, setLastRelapseDate] = useState('');
    const [lastTitle, setLastTitle] = useState('');
    const [lastDescription, setLastDescription] = useState('');
    const [lastLesson, setLastLesson] = useState('');
    const [lastImpact, setLastImpact] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const user = getUser();
    const token = getAccessToken();
    const today = new Date()
    const navigate = useNavigate();
    let logHidden = true;

    const [currentGoal, setCurrentGoal] = useState('');
    const [milestones, setMilestones] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showLearningPopup, setShowLearningPopup] = useState(false);
    const [learningContent, setLearningContent] = useState('');


    const relapseHandler = (event) => {
        event.preventDefault();
        navigate('/relapse');

    }

    async function fetchRelapseLog(){
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const moduleParams = {
            mode: 'default'
        };

        const requestBody = {
            username: user.username,
            token: token,
            module: moduleParams,
        }

        
        axios.post(logFetchUrl, requestBody, requestConfig).then(response => {
            try {
                setLastImpact(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseImpactDescriptionValue)
                setLastLesson(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseImprovementText)
                let lastTitleStart = 'Started on '
                let lastTitleEntryDate = convertTimestampToDateString(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].problematicUseStart))
                let lastTitleTemp = lastTitleStart + lastTitleEntryDate
                setLastTitle(lastTitleTemp)
                setLastRelapseDate(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].problematicUseEnd))
                setLastDescription(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseDescription)  
                if(response.data.dynamoContent.length>=1){
                    setLastSubmitDate(new Date(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].sk)))
                }
                for (let index = response.data.dynamoContent.length - 1; index >= 0; index--) {
                    const entry = response.data.dynamoContent[index];
                    entries.push(<ProblematicLogEntry lastSubmitDate = {new Date(Number(entry.sk)).toString()} lastImpact= {entry.relapseImpactDescriptionValue} lastLesson= {entry.relapseImprovementText} lastDescription= {entry.relapseDescription} lastTitle= {convertTimestampToDateString(Number(entry.problematicUseStart))} />)
                    entries.push(<hr></hr>)
                }
                setEntryHTML(entries)
                setTimerHTML(<div className="item"><Timer lastRelapseDate={lastRelapseDate}/></div>)
            } catch (error) {
                console.log('possibly no entry data yet')
                setEntryHTML(<h3>No Data Yet. As You Use Your Set Back Journal. Your Entries Will Show Here.</h3>)
                setLastTitle(<h4>No Data. Start Using Your Set Back Journal.</h4>)
            }
        }).catch(error => {
            console.error('fetch error: ', error);
            setErrorMessage('Sorry the server is down. Please try again later.');
            if(error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else if(error.response.status === 401 ){
                navigate('/login')
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
    }
    let questionsLearning = [
        {
            question: 'Set Back Log',
            assets: entryHTML,
        },
    ];

    const handleCloseLearningPopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0);
        setAnswers([]);
        document.getElementsByClassName("popupContainer")[0].style.display =  "none"
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "hidden"

    };
    const handleNextQuestion = () => {
        setCurrentQuestion(currentQuestion + 1);
    };

    const handlePreviousQuestion = () => {
        setCurrentQuestion(currentQuestion - 1);
    };

    const handleSubmitLearningClosePopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0);
        setAnswers([]);

    };

    const handleOpenLearningPopup = () => {
        setShowPopup(true);
        document.getElementById('learning-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "visible"
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "visible"
    };

    const renderFormLearning = () => {
        try{
            const currentQ = questionsLearning[currentQuestion];
            const { question, options } = currentQ;
            return (
                <div className="formContainer">
                    <div className="daily-popup-top-right">
                        <button type="button" className="landing-onboarding-top-close" onClick={handleCloseLearningPopup} aria-label="Close popup">x</button>
                    </div>
                    <h2 className="onboarding-popup-title">{question}</h2>
                    <div className="learningTextContent progressLogContent"> {currentQ.assets} </div>
                    <div className="popupButtonGroup">
                    {currentQuestion > 0 && currentQuestion < questionsLearning.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handlePreviousQuestion} style={{border:'none', background: 'none'}}>
                            <img className="previousBttn" src={nextBttn} alt="previousBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    {currentQuestion >= 0 && currentQuestion < questionsLearning.length - 3 ? (
                        <button type="button" className="homeBttn onboarding-pill-btn" aria-label="Next step" onClick={handleNextQuestion} style={{marginLeft: 'auto'}}>
                            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M3 7h8M7 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </button>
                    ) : (
                        null
                    )}
                    {currentQuestion === questionsLearning.length - 3 ? (
                        <button id="relapseSubmit" type="button" className="homeBttn onboarding-pill-btn" aria-label="Next step" style={{marginLeft: 'auto'}}>
                            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M3 7h8M7 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </button>
                    ) : (
                        null
                    )}
                    </div>
                </div>
            );
        
        }
        catch{
        }
        
    };

    useEffect(() => {    
        fetchRelapseLog()
    }, [])

    useEffect(() => {
        if (!user?.username || !token) return;

        const tzoffset = new Date().getTimezoneOffset() * 60000;
        const localISOTime = new Date(Date.now() - tzoffset).toISOString().slice(0, -1);
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB',
            },
        };
        const requestBody = {
            username: user.username,
            token,
            contentParams: { mode: 'default' },
            date: localISOTime,
        };

        axios
            .post(dailyContentUrl, requestBody, requestConfig)
            .then((response) => {
                const dynamoUserGoal = response?.data?.dynamoUserGoal;
                if (dynamoUserGoal != null && dynamoUserGoal !== '') {
                    const goalText =
                        typeof dynamoUserGoal === 'string'
                            ? dynamoUserGoal
                            : dynamoUserGoal?.textcontent || dynamoUserGoal?.text || '';
                    setCurrentGoal(goalText);
                }
            })
            .catch((err) => {
                console.error('Progress: fetch dynamoUserGoal failed', err);
                const stored = getUserGoal();
                if (stored) {
                    const goalText =
                        typeof stored === 'string'
                            ? stored
                            : stored?.textcontent || stored?.text || '';
                    setCurrentGoal(goalText);
                }
            });
    }, [user?.username, token]);

    useEffect(() => {
        if (!user?.username) return;
        fetchGoalMilestones(user.username)
            .then((data) => {
                if (data?.milestones?.length) {
                    setMilestones(data.milestones);
                }
            })
            .catch((err) => {
                console.error('Progress: fetchGoalMilestones failed', err);
            });
    }, [user?.username]);

    const handleGoalUpdate = (newGoal) => {
        setCurrentGoal(newGoal);
        const existing = getUserGoal();
        setUserGoal({
            ...(existing && typeof existing === 'object' ? existing : {}),
            textcontent: newGoal,
        });
    };
    return (
        <div className="wrapper progressScreen">
            <div className="dailyPopup">
                <div className="popupContainer" id="learning-popup"  style={{ display: 'none' }} >{renderFormLearning()}</div>
            </div>
            <div className='donut-parent'>
                <div className="donut"></div>
            </div>
            <div className="progressSurface">
                <div className="progressHeader">
                    <h2 className="dailyMainTitle">Mental Wellness <br/>Progress Overview</h2>
                </div>
                <GoalMilestoneCard
                    userId={user?.username || ''}
                    initialGoal={currentGoal}
                    initialMilestones={milestones}
                    onGoalUpdate={handleGoalUpdate}
                    onMilestonesUpdate={setMilestones}
                />
                <div className="progressOverviewCard">
                    <h4 className="progressInsightText"><span className="highlight">Latest Insight:</span> <TextExpander text={lastLesson} /></h4>
                    <h6 className="progressStreakText"><span>Current Streak: { lastTitle }</span></h6>
                    <div className="timer-container">
                        <div className="item">
                            <Timer lastRelapseDate={lastRelapseDate} />
                        </div>
                    </div>
                    <div className="homeBttnContainer progressActions">
                        <button className="homeBttn" onClick={handleOpenLearningPopup}>Show Set Back Log</button>
                    </div>
                </div>
            </div>
            {errorMessage && <p className="message"> { errorMessage } </p>}
        </div>
    )
}

export default Progress;
